import { Controller } from "@hotwired/stimulus"
import * as echarts from "echarts"
import moment from "moment"
import { groupReduce } from  "hb/lib/collection_helpers"

function formatBytes(bytes, decimals = 0) {
  if (bytes === 0) return '0 B';

  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

  const i = Math.floor(Math.log(bytes) / Math.log(k));

  return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export default class extends Controller {
  static targets = ["chartBody"]
  static values = {
    chartData: Object
  }

  connect() {
    this.chart = null;
    this.initializeChart();
  }

  disconnect() {
    this.chart?.dispose();
  }

  initializeChart() {
    const data = this.chartDataValue;
    const allDates = data.bins.map(bin => bin.ts);

    this.chart = echarts.init(this.chartBodyTarget);
    this.chart.setOption({
      legend: { show: false },
      xAxis: {
        type: 'time',
        min: data.start_at,
        max: data.end_at
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: (e) => formatBytes(e, 1),
        }
      },
      series: data.streams.map(stream => {
        const grouped = groupReduce(stream.bins, bin => bin.ts)

        return {
          name: stream.name,
          type: 'bar',
          stack: 'total',
          data: allDates.map(ts => [ts, grouped[ts]?.data_size || 0]),
        }
      }),
      animation: false,
      tooltip: {
        trigger: 'axis',
        valueFormatter: (e) => formatBytes(e, 1),
        axisPointer: {
          label: {
            formatter: function(params) {
              return moment(params.value).format("dddd, MMM D, h:mm a");
            },
          },
        },
      },
      dataZoom: [
        {
          start: 0,
          end: 100
        }
      ],
      grid: {
        containLabel: true,
        left: '0',
        right: '15',
        top: '10%',
        bottom: '10%',
      },
    });
  }

  resizeChart() {
    if (!this.chart) { return; }

    this.chart.resize();
  }
}
